import axios from './axiosInstance';

const RoomService = {
  async getRoom(roomId) {
    const response = await axios.get(`/rooms/${roomId}`);
    return response.data;
  },
};

export default RoomService;
